import "../../../WPSTransaction/PDF/Css/Download_pdf.css";

const PQR_Footer = ({
  pdf,
  PreviewUrl,
  previewuser,
  previewapproved,
  Band,
}) => {
  console.log(pdf[0], 'pdf[0]');
  const currentDate = new Date(pdf[0]?.WPSH_ApprovedBy_Date);

  const day1 = currentDate.getDate();
  const month1 = currentDate.getMonth() + 1;
  const year1 = currentDate.getFullYear();
  const WitnessedByDate = `${day1}-${month1}-${year1}`;

  const currentDate1 = new Date(pdf[0]?.WPSH_PreparedBy_Date);
  const day = currentDate1.getDate();
  const month = currentDate1.getMonth() + 1;
  const year = currentDate1.getFullYear();
  const PreparedByDate = `${day}-${month}-${year}`;

return(<>
<div style={{position:"relative", top:"0px"}}>
<table className="WPSnoborder" style={{ width: "70%"}}>
<tr>
<td className="WPSSignatureTable" style={{ width: "230px"}}>Welding Engineer</td>
{pdf[0]?.wld_WPSType !== "Groove" && <td className="WPSSignatureTable" style={{ position:"relative", left: "60px" }}>Witness By</td>}
</tr>
</table>
 <table id="table" className="WPSTable11">
 <tbody>
   <tr style={{borderBottom: "none" }}>
     <th style={{ borderBottom: "none" }}>Name</th>
     <th style={{ borderBottom: "none", borderLeft:"none", borderRight:"none" }}>Signature</th>
     <th style={{ borderBottom: "none" }}>Name</th>

     <th style={{ borderBottom: "none", borderLeft:"none" }}>Signature</th>
   </tr> 
   {pdf[0]?.wld_WPSType === "Tubesheet" ? 
   <td style={{ borderBottom: "none",height:"13px" }}>{pdf[0]?.WPSH_ApprovedBy_Name}</td>
   :
   <td style={{ borderBottom: "none",height:"13px" }}>{pdf[0]?.WPSH_PreparedBy_Name}</td> }

   <td rowSpan={3} style={{ borderLeft: "none" ,borderRight:"none", height: "40px" }}>
     {/* Signature space for manual signing - image removed */}
   </td>
   {pdf[0]?.wld_WPSType === "Tubesheet" ?  <><td style={{ borderBottom: "none" }}>{pdf[0]?.WPSH_WitnessBy_Name}</td></> : <><td style={{ borderBottom: "none" }}>{pdf[0]?.WPSH_ApprovedBy_Name}</td></>}
    
   
   <td rowSpan={3} style={{ borderLeft: "none", height: "40px" }}>
     {/* Signature space for manual signing - image removed */}
   </td>

   <tr>
     <th style={{ borderBottom: "none" }}>Date</th>

     <th style={{ borderBottom: "none" }}>Date</th>
   </tr>
   <tr>
     <td style={{height:"13px", paddingLeft:"3px"}}>{PreparedByDate === "NaN-NaN-NaN" ? "" : PreparedByDate}</td>
     <td style={{height:"13px", paddingLeft:"3px"}}>{WitnessedByDate === "NaN-NaN-NaN" ? "" : WitnessedByDate}</td>
   </tr>
 </tbody>
</table>
</div>

       
      
</>)
}

export default PQR_Footer; 
